
<div class="card-collection-fields">
  <card-image-upload
    v-model="card"
    allow-back-image
  />

  <select-input
    v-if="showCollectionSelector"
    v-model="card.collectionId"
    label="Collection"
    :options="collectionOptions"
  />

  <div v-if="!card.willManageQuantity" class="input-group">
    <currency-input
      id="investment"
      v-model="card.investment"
      label="Purchase Price"
      placeholder="1000"
      required
    />

    <date-input
      id="datePurchased"
      v-model="card.datePurchased"
      label="Purchase Date"
    />

    <text-input
      id="quantity"
      v-model="card.quantity"
      class="quantity-input"
      type="number"
      label="Quantity"
      placeholder="2"
      required
    />
  </div>

  <div>
    <checkbox
      v-if="!card.willManageQuantity"
      id="collection-sold"
      v-model="card.sold"
      label="Mark as sold"
    />
  </div>

  <div v-if="!card.willManageQuantity && card.sold" class="input-group">
    <currency-input
      id="priceSold"
      v-model="card.priceSold"
      placeholder="2000"
      label="Sale Price"
      :required="card.sold"
    />

    <date-input
      id="dateSold"
      v-model="card.dateSold"
      label="Sale Date"
    />
  </div>

  <div>
    <checkbox
      id="manage-quantity"
      v-model="card.willManageQuantity"
      label="Manage multiple quantity"
    />
  </div>

  <card-collection-quantity
    v-if="card.willManageQuantity"
    v-model="card.individualCards"
    :card="card"
  />

  <div>
    <checkbox
      v-if="!card.willManageQuantity"
      id="collection-ownership"
      v-model="card.ownsPercentage"
      label="Setup fractional ownership"
    />
  </div>

  <div v-if="!card.willManageQuantity && card.ownsPercentage">
    <text-input
      v-model="card.ownershipPercentage"
      type="decimal"
      label="What percentage do you own?"
      placeholder="50"
    />
  </div>

  <div>
    <checkbox
      v-if="card.cardId || card.useGradedCardAutomatic"
      id="collection-use-last-sold"
      v-model="card.useLastSoldValue"
      label="Use the last sold price to track value"
    />
  </div>

  <div>
    <checkbox
      v-if="isPublicCollection"
      id="collection-hide-showcase"
      v-model="card.hideFromShowcase"
      label="Hide from Showcase"
    />
  </div>

  <text-area-input
    v-model="card.notes"
    label="Notes"
  />
</div>
